import { Typography, makeStyles } from '@material-ui/core'

import TrialImage from 'assets/images/trial-end.png'

import { DialogBody } from './DialogBody'

import { useRoles } from 'hooks'
import { useDispatch } from 'react-redux'
import { openLink } from 'modules'
import { showPlanDialog } from 'ducks'

const yellow = 'rgba(253, 212, 95, 0.9)'
const yellowLight = 'rgba(255, 218, 163, 0.9)'

const useStyles = makeStyles(theme => ({
    secondaryAction: {
        cursor: 'pointer',
        textDecoration: 'underline',
        color: '#001a36',
        marginTop: theme.spacing(2)
    }
}))

type Props = {
    onClose: () => void
}

export const TrialEndDialog = ({ onClose }: Props) => {
    const { isAdmin } = useRoles()
    const dispatch = useDispatch()
    const classes = useStyles(isAdmin)

    const openDemoPage = () => {
        openLink('https://meetings.hubspot.com/ngiat/book-a-demo-with-guidde', '_blank')
    }

    return (
        <DialogBody
            isOpen
            skipAdmin
            onClose={onClose}
            image={TrialImage}
            bubblesBackground={[yellow, yellowLight]}
            onPrimaryClick={() => {
                if (isAdmin) {
                    dispatch(showPlanDialog('upgradePlanDialog'))
                } else {
                    openDemoPage()
                }
            }}
            primaryText={isAdmin ? 'See plans' : 'Book a demo'}
            secondaryButton={
                <>
                    {isAdmin && (
                        <Typography
                            variant="subtitle2"
                            className={classes.secondaryAction}
                            onClick={openDemoPage}
                        >
                            Book a demo
                        </Typography>
                    )}
                </>
            }
            title="Your trial has expired"
            text={
                <Typography>
                    We’ve reverted your account to the Free plan. Worry not! All your how-to videos
                    are safe forever.{' '}
                    {isAdmin
                        ? 'Check out our plans and see what you’re missing out on.'
                        : 'Reach out to your admin to upgrade or book a demo, and we’ll help you get going.'}
                </Typography>
            }
        />
    )
}
